import { render, staticRenderFns } from "./history.html?vue&type=template&id=087d8a4d&scoped=true&"
import script from "./history.js?vue&type=script&lang=js&"
export * from "./history.js?vue&type=script&lang=js&"
import style0 from "./history.sass?vue&type=style&index=0&id=087d8a4d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d8a4d",
  null
  
)

component.options.__file = "history.vue"
export default component.exports